import { d as t } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var s = {
  name: "cv",
  weekdays: "вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),
  months: "кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),
  weekStart: 1,
  weekdaysShort: "выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),
  monthsShort: "кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),
  weekdaysMin: "вр_тн_ыт_юн_кҫ_эр_шм".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD-MM-YYYY",
    LL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",
    LLL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",
    LLLL: "dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"
  }
};
t.locale(s, null, !0);
export {
  s as default
};
